import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-2ac9d7cc"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "head-view page-lines"
};
const _hoisted_2 = {
  class: "name"
};
const _hoisted_3 = {
  class: "count"
};

const _hoisted_4 = /*#__PURE__*/_createTextVNode("人热议 ");

export default {
  props: {
    name: String,
    count: Number
  },

  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("p", _hoisted_2, _toDisplayString(__props.name), 1), _createElementVNode("p", _hoisted_3, [_createElementVNode("span", null, _toDisplayString(__props.count), 1), _hoisted_4])]);
    };
  }

};